import * as types from './types';
// eslint-disable-next-line import/no-cycle
import axios from '@/lib/axios';
// import storage from "store";
import { errCodeMap } from '@/lib/errors';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    isDialogCrowdShopwindow: false,
    tableData: [],
    pageInfoCrowd: {
      size: 1,
      count: 10,
      total: 20,
    },
  },
  mutations: {
    [types.SET_TABLE_DATA](state, data) {
      state.tableData = data;
    },
    [types.SET_DIALOG_CROWD_SHOPWINDOW](state, isDialog) {
      state.isDialogCrowdShopwindow = isDialog;
    },
    // Q群页码区域
    [types.SET_Q_CROWD_PAGE_SIZE](state, size) {
      state.pageInfoCrowd.size = size;
    },
    [types.SET_Q_CROWD_PAGE_COUNT](state, count) {
      state.pageInfoCrowd.count = count;
    },
    [types.SET_Q_CROWD_PAGE_TOTAL](state, total) {
      state.pageInfoCrowd.total = total;
    },
  },
  actions: {
    async fetchQqCrowd({ commit, state, rootState }) {
      const { size, count } = state.pageInfoCrowd;
      const { userCenter } = rootState;
      const { profile } = userCenter;

      const params = {
        method: 'post',
        body: {
          user_id: profile.user_id,
          media_type: 4, // 1-微视  2-k歌  4 qq
          content_type: 41, // 内容类型 qq群橱窗
          page: size,
          count,
        },
      };

      const res = await axios
        .post('v1/cp/media/content/list', params)
        .catch(() => {
          Vue.prototype.$tip.error('获取用户下绑定的qq橱窗及群橱窗列表失败');
        });

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '获取用户下绑定的qq橱窗及群橱窗列表失败');
        return;
      }

      commit(types.SET_TABLE_DATA, res.data.content_list);
      commit(types.SET_Q_CROWD_PAGE_TOTAL, res.data.page_info.total);
    },
  },
};
